(function () {
	const searchModal = () => {
		$(".search-modal-trigger,.search-modal__overlay,.search__close").click(
			function (e) {
				e.preventDefault();
				searchToggle();
			}
		);
	};
	$(document).on("keyup", function (e) {
		if ($(".search-modal").hasClass("active") && e.key == "Escape") {
			searchToggle();
		}
	});
	function searchToggle() {
		$("#search-modal").toggleClass("active");
		if ($("#search-modal").hasClass("active")) {
			// Close the mega menu first so it does not sit under / over the drawer.
			document.dispatchEvent(new CustomEvent("header:close-mega"));
			lockPage(true);
			$("#search-modal").find(".search__input")[0].focus();
		} else {
			lockPage(false);
			$(".search-modal-trigger").focus();
		}
	}
	// overflow:hidden on <body> does not stop touch scrolling on iOS Safari, so
	// pin the page in place and restore the scroll position when it closes.
	let lockedScrollY = 0;
	function lockPage(lock) {
		const body = document.body;
		if (lock) {
			lockedScrollY = window.scrollY;
			body.classList.add('overflow-hidden');
			body.style.position = 'fixed';
			body.style.top = `-${lockedScrollY}px`;
			body.style.left = '0';
			body.style.right = '0';
		} else {
			body.classList.remove('overflow-hidden');
			body.style.position = '';
			body.style.top = '';
			body.style.left = '';
			body.style.right = '';
			window.scrollTo(0, lockedScrollY);
		}
	}
	document.addEventListener("shopify:section:load", searchModal);
	searchModal();
})();
